import { getLightColorName } from '@/common/rgb-light-color'
//设备类型的判断以展示不用的item样式
const deviceTypeJudge = oneDevice => {
  let ViewType = ''
  if (
    oneDevice.productCode === '01' ||
    oneDevice.productCode === '05' ||
    oneDevice.productCode === '021'|| 
    oneDevice.productCode ===  '048'  //代号 20231207-1
  ) {
    // 05 感应器 //01 4路通断 021 F路通断
    ViewType = '开关样式'
  } else if (
    oneDevice.productCode === '014' ||
    oneDevice.productCode === '06' ||
    oneDevice.productCode === '02' ||
    oneDevice.productCode === '010'||
    oneDevice.productCode === '049'//代号 20231207-1
  ) {
    // 014 F路调光  06 A电机 02 两路调光
    ViewType = '调光样式'
  } else if (oneDevice.productCode === '03') {
    //  03 四键面板
    ViewType = '四键'
  } else if (oneDevice.productCode === '07') {
    ///07 门锁
    ViewType = '门锁'
  } else if (oneDevice.productCode === '08') {
    ///08 A空调控制
    ViewType = '空调'
  } else if (oneDevice.productCode === '09') {
    // 09 八键面板
    ViewType = '八键'
  } else if (oneDevice.productCode === '013') {
    /// 013 安防控制
    ViewType = '安防'
  } else if (oneDevice.productCode === '015') {
    ///015 A0电机控制
    ViewType = 'A0电机'
  } else if (oneDevice.productCode === '016') {
    ////016  三合一八键环境面板
    ViewType = '环境面板'
  } else if (oneDevice.productCode === '017') {
    //017 A地暖
    ViewType = '地暖'
  } else if (oneDevice.productCode === '018') {
    //018 A新风控制
    ViewType = '新风'
  } else if (oneDevice.productCode === '019') {
    //019 环境探测器
    ViewType = '探测'
  } else if (oneDevice.productCode === '020') {
    //020 F键面板
    ViewType = 'F键面板'
  } else if (oneDevice.productCode === '022') {
    //022 A定时控制
    ViewType = '定时'
  } else if (oneDevice.productCode === '023') {
    //023 F路影视控制
    ViewType = '影视'
  } else if (oneDevice.productCode === '024') {
    //024 A音乐控制
    ViewType = 'A音乐'
  } else if (oneDevice.productCode === '025') {
    // 025 F双色控制
    ViewType = '双色'
  } else if (oneDevice.productCode === '026') {
    // //026 F三色控制
    ViewType = '三色'
  } else if (oneDevice.productCode === '029') {
    ViewType = 'RGBW调光'
  } else if (oneDevice.productCode === '030') {
    ViewType = 'RGB调光'
  } else if (oneDevice.productCode === '027') {
    //027 W1智能插座
    ViewType = '插座'
  }
  return ViewType
}
//计算出item右下角根据设备状态应该显示的文字
const deviceTypeJudge1 = oneDevice => {
  let value = ''
  if (oneDevice.productCode === '06' || oneDevice.productCode === '010') {//代号20200804-1
    ///说明是A电动窗帘
    if (oneDevice.openStateValue > 0) {
      value = '开/升'
    } else {
      value = '关/降'
    }
  } else if (
    oneDevice.productCode === '03' ||
    oneDevice.productCode === '09' ||
    oneDevice.productCode === '020'
  ) {
    ///4键 8键 F键面板
  } else if (oneDevice.productCode === '025') {
    ///说明是双色调光控制
    if (oneDevice.openState <= 0 && oneDevice.openStateValue <= 0) {
      value = '关'
    } else {
      value = '开'
    }
  } else if (oneDevice.productCode === '026') {
    ///说明是三色调光控制
    if (
      oneDevice.openState <= 0 &&
      oneDevice.openStateValue <= 0 &&
      oneDevice.openStateValue1 <= 0
    ) {
      value = '关'
    } else {
      value = '开'
    }
  } else if (oneDevice.productCode === '029' || oneDevice.productCode === '030') {
    if (
      oneDevice.openState <= 0 && oneDevice.openStateValue <= 0 &&
      oneDevice.openStateValue1 <= 0 &&
      (oneDevice.productCode !== '029' || oneDevice.openStateValue2 <= 0) &&
      oneDevice.openStateValue3 <= 0
    ) {
      value = '关'
    } else {
      value = '开'
    }
  } else if (oneDevice.productCode === '015') {
    //说明是A0电机  有BUG 显示的开关状态和实际的可能对不上，因为用户点了停止的时候，不知道窗帘的状态，所以停止的时候也默认了窗帘是开的状态
    if (oneDevice.openState === 2) {
      value = '关/降'
    } else {
      value = '开/升'
    }
  } else if (
    oneDevice.productCode === '019' ||
    oneDevice.productCode === '023' ||
    oneDevice.productCode === '024'
  ) {
    //说明是环境探测 音乐 影音设备///不需要有状态展示 20200329同移动端一起补的BUG
    value = ''
  } else {
    //说明是通用开关样式
    if (oneDevice.openState === 1) {
      value = '开'
    } else if (oneDevice.openState === 0) {
      value = '关'
    }
  }

  return value
}

///对设备状态 0 和1 进行判断和翻转  参数data为一个设备的综合数据
const deviceStateFlip = oneDevice => {
  if (oneDevice.openState === 0) {
    return (oneDevice.openState = 1)
  } else {
    return (oneDevice.openState = 0)
  }
}
/*
// 功能： 只要传入的多个类型数据...Type 其中有一个 和oneDeviceType相同就会返回true，否则返回false
// oneDeviceType 传入要判断的设备类型码     ...Type  不定参数可以有多个类型数据传入，
 使用示例  
//判断当前设备类型  是否和后面的'01' , '021' , '05'相同，相同返回true  都不相同返回false
// if( publicDeviceTypeJudge(this.oneDevice.productCode, '01' , '021' , '05') )   
*/
// 卡片视觉状态只归一化现有设备状态，不参与控制请求或状态翻转。
const getDeviceVisualStatus = (oneDevice, userOneDevice) => {
  const productCode = String(oneDevice.productCode || '');
  // 019没有设备列表实时状态；023/024的openState是遥控命令，不是可靠开关状态。
  const noSwitchStateCodes = ['03', '09', '019', '020', '023', '024'];

  if (noSwitchStateCodes.indexOf(productCode) !== -1) {
    return {
      state: 'neutral',
      label: ''
    };
  }

  const stateText = deviceTypeJudge1(oneDevice, userOneDevice);
  if (stateText === '开' || stateText === '开/升') {
    return { state: 'active', label: stateText };
  }
  if (stateText === '关' || stateText === '关/降') {
    return { state: 'inactive', label: stateText };
  }
  return { state: 'neutral', label: '' };
}

const AIR_CONDITIONER_MODE_TEXT = {
  1: '制冷',
  2: '除湿',
  3: '通风',
  4: '制热',
  5: '自动'
};

const AIR_CONDITIONER_WIND_TEXT = {
  1: '自动',
  2: '低速',
  4: '中速',
  6: '高速'
};

const NEW_TREND_MODE_TEXT = {
  1: '内循环',
  2: '外循环'
};

const RGBW_MODE_TEXT = {
  1: '红光呼吸',
  2: '绿光呼吸',
  3: '蓝光呼吸',
  4: '白光呼吸',
  5: 'RGB呼吸',
  6: '黄光呼吸',
  7: '紫光呼吸'
};

const readBoundedNumber = (value, min, max) => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  if (!isFinite(number) || number < min || number > max) return null;
  return Math.round(number);
};

const formatPercent = value => {
  const percent = readBoundedNumber(value, 0, 100);
  return percent === null ? '' : percent + '%';
};

const formatEnvironmentStatus = oneDevice => {
  const status = [];
  const temperatureDisplay = String(oneDevice.temperatureDisplay || '').trim();
  const humidityDisplay = String(oneDevice.humidityDisplay || '').trim();

  if (temperatureDisplay) status.push('室温' + temperatureDisplay);
  if (humidityDisplay) status.push('湿度' + humidityDisplay);
  return status.join(' ');
};

const formatAirConditionerCardStatus = (userOneDevice, oneDevice) => {
  const openState = Number(userOneDevice.openState);
  if (openState === 0) {
    return { primary: '关', secondary: formatEnvironmentStatus(oneDevice) };
  }
  if (openState !== 1) return { primary: '', secondary: formatEnvironmentStatus(oneDevice) };

  const details = ['开'];
  const modeText = AIR_CONDITIONER_MODE_TEXT[Number(userOneDevice.openStateValue)];
  if (modeText) details.push(modeText);

  const temperature = Number(userOneDevice.openStateValue1);
  if (!isNaN(temperature) && temperature >= 16 && temperature <= 30) {
    details.push(Math.round(temperature) + '°');
  }

  const windText = AIR_CONDITIONER_WIND_TEXT[Number(userOneDevice.openStateValue2)];
  if (windText) details.push(windText);

  return {
    primary: details.join(' '),
    secondary: formatEnvironmentStatus(oneDevice)
  };
};

const formatFloorHeatingCardStatus = (userOneDevice, oneDevice) => {
  const openState = Number(userOneDevice.openState);
  const isOpen = openState === 1;
  const details = [isOpen ? '开' : openState === 0 ? '关' : ''];
  const setTemperature = readBoundedNumber(userOneDevice.openStateValue1, 16, 30);
  if (isOpen && setTemperature !== null) details.push(setTemperature + '°');
  return { primary: details.join(' '), secondary: formatEnvironmentStatus(oneDevice) };
};

const formatNewTrendCardStatus = (userOneDevice, oneDevice) => {
  const openState = Number(userOneDevice.openState);
  if (openState === 0) {
    return { primary: '关', secondary: formatEnvironmentStatus(oneDevice) };
  }
  if (openState !== 1) return { primary: '', secondary: formatEnvironmentStatus(oneDevice) };
  const details = ['开'];
  const modeText = NEW_TREND_MODE_TEXT[Number(userOneDevice.openStateValue)];
  const windText = AIR_CONDITIONER_WIND_TEXT[Number(userOneDevice.openStateValue2)];
  if (modeText) details.push(modeText);
  if (windText) details.push(windText);
  return { primary: details.join(' '), secondary: formatEnvironmentStatus(oneDevice) };
};

const formatDimmingCardStatus = (userOneDevice, oneDevice, visualStatus) => {
  const brightness = formatPercent(userOneDevice.openStateValue);
  return {
    primary: visualStatus.label,
    secondary: visualStatus.state === 'active' && brightness ? '亮度' + brightness : ''
  };
};

const formatMotorCardStatus = (userOneDevice, oneDevice, visualStatus) => {
  const position = formatPercent(userOneDevice.openStateValue);
  return { primary: visualStatus.label, secondary: position ? '位置' + position : '' };
};

const formatDoorLockCardStatus = userOneDevice => {
  const openState = Number(userOneDevice.openState);
  return { primary: openState === 1 ? '开锁' : openState === 0 ? '关锁' : '', secondary: '' };
};

const formatSecurityCardStatus = userOneDevice => {
  const openState = Number(userOneDevice.openState);
  return { primary: openState === 1 ? '布防' : openState === 0 ? '撤防' : '', secondary: '' };
};

const formatDualDimmingCardStatus = (userOneDevice, oneDevice, visualStatus) => {
  const details = [];
  const white = formatPercent(userOneDevice.openState);
  const warm = formatPercent(userOneDevice.openStateValue);
  if (white) details.push('白' + white);
  if (warm) details.push('暖' + warm);
  return { primary: visualStatus.label, secondary: visualStatus.state === 'active' ? details.join(' ') : '' };
};

const formatRgbCardStatus = (userOneDevice, oneDevice, visualStatus) => {
  return { primary: visualStatus.label, secondary: '' };
};

const formatRgbwCardStatus = (userOneDevice, oneDevice, visualStatus) => {
  if (visualStatus.state !== 'active') return { primary: visualStatus.label, secondary: '' };
  const modeText = RGBW_MODE_TEXT[Number(userOneDevice.openStateValue3)];
  if (modeText) return { primary: visualStatus.label, secondary: modeText };
  const white = String(oneDevice.productCode) === '029' ? userOneDevice.openStateValue2 : 0;
  const colorName = getLightColorName(userOneDevice.openState, userOneDevice.openStateValue,
    userOneDevice.openStateValue1, white);
  return { primary: visualStatus.label, secondary: colorName };
};

const DEVICE_CARD_STATUS_FORMATTERS = {
  '08': formatAirConditionerCardStatus,
  '016': formatAirConditionerCardStatus,
  '017': formatFloorHeatingCardStatus,
  '018': formatNewTrendCardStatus,
  '02': formatDimmingCardStatus,
  '014': formatDimmingCardStatus,
  '049': formatDimmingCardStatus,
  '06': formatMotorCardStatus,
  '010': formatMotorCardStatus,
  '07': formatDoorLockCardStatus,
  '013': formatSecurityCardStatus,
  '025': formatDualDimmingCardStatus,
  '026': formatRgbCardStatus,
  '029': formatRgbwCardStatus,
  '030': formatRgbwCardStatus
};

/**
 * 设备卡片状态的唯一展示入口。返回固定的主/辅助两层结构，模板不感知产品字段。
 * 后续扩展产品时只增加格式化规则，不修改卡片排版和控制链路。
 */
const getDeviceCardStatus = (oneDevice, userOneDevice) => {
  const visualStatus = getDeviceVisualStatus(oneDevice, userOneDevice);
  const productCode = String(oneDevice.productCode || '');
  let primary = visualStatus.label;
  let secondary = '';

  const productFormatter = DEVICE_CARD_STATUS_FORMATTERS[productCode];
  if (productFormatter) {
    const formattedStatus = productFormatter(userOneDevice, oneDevice, visualStatus);
    primary = formattedStatus.primary;
    secondary = formattedStatus.secondary;
  }

  return {
    state: visualStatus.state,
    primary,
    secondary
  };
};

///对设备状态 0 和1 进行判断和翻转  参数data为一个设备的综合数据
const publicDeviceTypeJudge = (oneDeviceType, ...Type) => {
  var numargs = Type.length
  for (let i = 0; i < numargs; i++) {
    if (oneDeviceType === Type[i]) return true
  }
  return false
}

export { getDeviceVisualStatus, formatEnvironmentStatus, getDeviceCardStatus,
  deviceTypeJudge,
  deviceTypeJudge1,
  publicDeviceTypeJudge,
  deviceStateFlip
}
